<div class="flex flex-col flex-auto w-full">
    <div class="flex flex-row relative mb-4" *ngIf="dialogRef">
        <button class="absolute right-0" mat-button (click)="dialogRef.close()">X</button>
    </div>
    <ng-container *transloco="let t">
        <div class="flex flex-wrap w-full max-w-screen-xl mx-auto">
            <div class="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-8 w-full ">
                <div
                    class="sm:col-span-2 lg:col-span-3 flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
                    <!-- Kopf: Titel links, Zeitraum rechts; im schmalen Dialog bricht der Zeitraum in eine eigene Zeile um -->
                    <div class="flex flex-wrap items-start justify-between gap-x-4 gap-y-3 mt-10 ml-6 mr-6 sm:ml-10 sm:mr-10">
                        <div class="flex flex-col">
                            <div class="mr-4 text-2xl md:text-3xl font-semibold tracking-tight leading-7">
                                {{t('temperature-title')}}
                            </div>
                            <div class="font-medium text-secondary">{{ sourceLabel ? 'Quelle: ' + sourceLabel : '' }}</div>
                        </div>
                        <div class="ml-2">
                            <mat-button-toggle-group class="hidden sm:inline-flex border-none space-x-1" value="7"
                                #visitorsYearSelector="matButtonToggleGroup" (change)="updateTimeRage($event?.value)">
                                <mat-button-toggle class=" px-1.5 rounded-full overflow-hidden border-none font-medium"
                                    value="1"> {{t('last-24-hours')}}
                                </mat-button-toggle>
                                <mat-button-toggle class=" px-1.5 rounded-full overflow-hidden border-none font-medium"
                                    value="7">{{t('last-7-days')}}
                                </mat-button-toggle>
                                <!-- 30 Tage nur im Admin; im Kundenportal-Dialog reichen 24 h und 7 Tage -->
                                <mat-button-toggle class="px-1.5 rounded-full overflow-hidden border-none font-medium"
                                    value="30" *ngIf="!dialogRef">{{t('last-30-days')}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                            <div class="sm:hidden">
                                <button mat-icon-button [matMenuTriggerFor]="timeMenu">
                                    <mat-icon [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
                                </button>
                                <mat-menu #timeMenu="matMenu">
                                    <button mat-menu-item (click)="updateTimeRage(1)">{{t('last-24-hours')}}</button>
                                    <button mat-menu-item (click)="updateTimeRage(7)">{{t('last-7-days')}}</button>
                                    <button mat-menu-item (click)="updateTimeRage(30)" *ngIf="!dialogRef">{{t('last-30-days')}}</button>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col flex-auto h-80" *ngIf="!chartLoaded && !loadFailed">
                        <p class="m-8 font-medium">Loading...</p>
                    </div>
                    <div class="flex flex-col flex-auto h-80" *ngIf="loadFailed">
                        <p class="m-8 font-medium text-secondary">{{t('sensor-values-unavailable')}}</p>
                    </div>
                    <div class="flex flex-col flex-auto h-80" *ngIf="chartLoaded">
                        <apx-chart class="flex-auto w-full h-full mb-8" [chart]="chartOptions.chart"
                            [colors]="chartOptions.colors" [dataLabels]="chartOptions.dataLabels"
                            [fill]="chartOptions.fill" [grid]="chartOptions.grid" [series]="chartOptions.series"
                            [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip" [xaxis]="chartOptions.xaxis"
                            [yaxis]="chartOptions.yaxis">
                        </apx-chart>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>